(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches) return;

  /* Revelação ao rolar: marca seções e cartões */
  const targets = [];
  const mark = (selector, fx, stagger) => {
    document.querySelectorAll(selector).forEach((el, i) => {
      el.classList.add('al-fx');
      if (fx) el.dataset.fx = fx;
      if (stagger) el.dataset.fxDelay = String((i % stagger) + 1 > 3 ? 3 : (i % stagger) + (i % stagger ? 1 : 0));
      targets.push(el);
    });
  };
  mark('.al-collections a', 'zoom', 3);
  mark('.al-journal__article', null, 3);
  mark('.al-journal__header', 'left');
  mark('.lov-hr-card', null, 3);
  mark('.lov-hr-head', 'left');
  mark('.al-benefits > div', null, 3);

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  targets.forEach((el) => io.observe(el));

  /* Parallax suave no banner visível */
  const heroes = [...document.querySelectorAll('.al-home__hero')];
  const carousel = document.querySelector('al-banner-carousel');
  if (heroes.length && carousel) {
    let ticking = false;
    const parallax = () => {
      ticking = false;
      const rect = carousel.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > innerHeight) return;
      const progress = Math.min(1, Math.max(0, -rect.top / rect.height));
      heroes.forEach((hero) => {
        const img = hero.querySelector('img');
        if (img) img.style.translate = `0 ${progress * 60}px`;
      });
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(parallax); } }, { passive: true });
  }

  /* Marca slide ativo para o Ken Burns */
  const track = document.querySelector('[data-banner-track]');
  if (track) {
    const setActive = () => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      heroes.forEach((hero, i) => hero.classList.toggle('is-active', i === index));
    };
    track.addEventListener('scroll', () => requestAnimationFrame(setActive), { passive: true });
    setActive();
  }
})();
